
import { Component, Vue } from 'vue-property-decorator';
import {
    GetPatientDetail, GetNewsTems, GetTemList, GetContentDetail,
    GetZhengzhuang, GetTuijianOptions, GetTuijianzhengxings,
    PostCepingContent, EditContent, PostAiTizhi
} from '../../request';
import { getCurrentTime } from '../../common';
@Component({
    components: {},
})
export default class AiWen extends Vue {
    private showPrescriptionDialog: boolean = false;
    private data: any = {
        template: {},
        collect_time: '',
        data: [],
        report: {
            易发症状: [],
            中医体质: [],
            舌面脉: {
                舌: null,
                面: null,
                舌下: null,
                脉: null,
            },
            建议: {}
        },
    };
    private tizhiOpts: any = [
        '阳虚质',
        '阴虚质',
        '气虚质',
        '痰湿质',
        '湿热质',
        '血瘀质',
        '气郁质',
        '特禀质',
        '平和质'
    ]
    private patient: any = {};
    private dataQuery: any = {
        name: "",
        template_id: "",
        patient_id: "",
    };
    private step: any = 1;
    private selectedIds: any = [];
    private options: string[] = [
        '起床后精力无法应对全天活动',
        '睡眠不好、晨起困倦',
        '食欲不佳、餐后腹胀',
        '情绪不能较快平复',
        '温差变化时明显怕冷怕热',
        '大便不成形、黏马桶',
        '排尿不正常、有尿频或尿黄',
        '运动后30分钟内体力无法恢复',
        '说话声音低弱、气短',
        '接触花粉/尘螨后易发生不适',
        '平时明显痰多',
        '身体某些部位会出现刺痛感'
    ]
    private getZhengzhuang() {
        const arr = this.data.report['易发症状'];
        // 现在 arr 中存储的是字符串，直接使用即可
        return arr.join('；');
    }
    private isSelected(arr: any, item: string) {
        return arr.findIndex((val: any) => val === item) !== -1;
    }
    private goReport(name: any) {
        this.$router.push({
            path: "/main/report/ceping-report",
            query: {
                ids: JSON.stringify([this.data.report['舌面脉'][name].content_id]),
                ifShowFengmian: "否",
            },
        });
    }
    /**
     * 上一步
     */
    private prev() {
        if (this.step == 1) {
            this.$router.back();
        } else {
            this.step -= 1;
            this.scrollToTop();
        }
    }
    /**
     * 下一步
     */
    private async next() {
        console.log('数据')
        console.log(this.data.report['易发症状']);
        if (this.data.report['易发症状'].length == 0) {
            this.$message.error('请至少选择一个症状');
            return;
        }
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
            patient_id: this.dataQuery.patient_id,
            zhengzhuang_list: this.data.report['易发症状'],
        };
        const res = await PostAiTizhi(this, params, loading);
        console.log(res);
        loading.close();
        this.data.report['中医体质'] = res.data.tizhis;
        this.step = 2;
        this.scrollToTop();

    }

    // 滚动到顶部的方法
    scrollToTop() {
        this.$nextTick(() => {
            const contentElement = document.querySelector('#scroll-box') as HTMLElement;
            if (contentElement) {
                contentElement.scrollTop = 0;
            }
        });
    }

    private selectZhengzhuang(item: string) {
        if (this.data.report && this.data.report['易发症状'] && this.isSelected(this.data.report['易发症状'], item)) {
            // 移除项目
            const newArray = this.data.report['易发症状'].filter((val: any) => val !== item);
            this.$set(this.data.report, '易发症状', newArray);
        } else {
            console.log(this.data.report['易发症状'])
            const newArray = [...this.data.report['易发症状'], item];
            this.$set(this.data.report, '易发症状', newArray);
            // 添加项目
            // if (this.data.report && this.data.report['易发症状'] && this.data.report['易发症状'].length < 2) {
            //     const newArray = [...this.data.report['易发症状'], item];
            //     this.$set(this.data.report, '易发症状', newArray);
            // } else {
            //     this.$message.error('最多选择2个');
            // }
        }
    }
    private selectTizhi(item: any) {
        if (this.data.report && this.data.report['中医体质'] && this.data.report['中医体质'].includes(item)) {
            const newArray = this.data.report['中医体质'].filter((val: any) => val !== item);
            this.$set(this.data.report, '中医体质', newArray);
        } else {
            if (this.data.report && this.data.report['中医体质'] && this.data.report['中医体质'].length < 1) {
                const newArray = [...this.data.report['中医体质'], item];
                this.$set(this.data.report, '中医体质', newArray);
            } else {
                // this.$message.error('最多选择1个');
                this.data.report['中医体质'] = [item];
            }
        }
    }
    /**
     * 获取患者数据
     */
    private getPatientData() {
        if (!this.dataQuery.patient_id) {
            return;
        }
        GetPatientDetail(this, this.dataQuery.patient_id).then((res: any) => {
            this.patient = res.data;
            this.$store.commit("updatePatient", this.patient);
        });
    }
    /**
     * 获取舌面脉数据
     */
    private async getShemianmaiData() {
        // 需要调取接口拿数据 
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
            params: {
                patient_id: this.dataQuery.patient_id,
                related_type: "四诊客观化数据",
            },
        };
        const newstData = await GetNewsTems(this, params, loading);
        //从这里封装一个方法，根据name获取数据
        const sheData = await this.getCurrentData(newstData.data['四诊客观化数据'], '舌');
        const mianData = await this.getCurrentData(newstData.data['四诊客观化数据'], '面');
        const shexiaData = await this.getCurrentData(newstData.data['四诊客观化数据'], '舌下');
        const maiData = await this.getCurrentData(newstData.data['四诊客观化数据'], '脉');
        if (sheData) {
            this.selectedIds.push(sheData.content_id);
        }
        if (mianData) {
            this.selectedIds.push(mianData.content_id);
        }
        if (shexiaData) {
            this.selectedIds.push(shexiaData.content_id);
        }
        if (maiData) {
            this.selectedIds.push(maiData.content_id);
        }
        this.data.report['舌面脉']['舌'] = sheData;
        this.data.report['舌面脉']['面'] = mianData;
        this.data.report['舌面脉']['舌下'] = shexiaData;
        this.data.report['舌面脉']['脉'] = maiData;
        this.$forceUpdate();
    }
    /**
     * 提取最新舌面脉数据
     * @param arr 
     * @param name 
     */
    private async getCurrentData(arr: any, name: any) {
        let item;
        if (name === "舌") {
            item = arr.find((item: any) => item.name.includes("舌") && !item.name.includes("舌下"));
        } else if (name === "舌下") {
            item = arr.find((item: any) => item.name.includes("舌下"));
        } else {
            item = arr.find((item: any) => item.name.includes(name));
        }
        if (item && item.content_id && item.collect_time) {
            const today = getCurrentTime("yyyy-MM-dd");
            if (item.collect_time.includes(today)) {
                return item;
            }
        }
        return null;
    }
    /**
     * 获取数据
     */
    private getData() {
        this.data = {};
        // 特殊量表，正常是不会有content_id，因为只会是新增进入
        if (this.dataQuery.content_id) {
            this.getContent();
        } else {
            this.getTemplate();
        }
    }
    /**
     * 获取量表模版
     */
    private getTemplate() {
        const params: any = {
            params: {
                name: this.dataQuery.name,
                page: 1,
                ignore_permissions: "true",
            },
        };
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        GetTemList(this, params, loading).then((res: any) => {
            this.data = {
                template: res.data[0],
                collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
                data: res.data[0].fields,
                report: {
                    易发症状: [],
                    中医体质: [],
                    舌面脉: {
                        舌: null,
                        面: null,
                        舌下: null,
                        脉: null,
                    },
                    建议: {}
                },
            };
            this.$forceUpdate();
        });
    }
    /**
     * 获取量表数据
     */
    private getContent() {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        GetContentDetail(this, this.dataQuery.content_id, loading).then(
            (res: any) => {
                this.data = res.data;
                if (!this.data.name && this.data.template && this.data.template.name) {
                    this.data.name = this.data.template.name;
                }
            }
        );
    }
    /**
     * 保存
     */
    private async save() {
        try {
            //this.dataQuery.content_id不会有值，因为正常是新增进入，这里先占位
            let res: any;
            if (!this.dataQuery.content_id) {
                res = await this.saveTemplate(this.data);
            } else {
                res = await this.saveContent(this.data);
            }
            this.$message.success("保存成功！");
            this.$store.commit("updateIfCompose", false);
            this.$emit('saveSuccess', res.data);
        } catch (error) {
            console.log(error);
        }
    }
    private async saveTemplate(data: any) {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        try {
            const params: any = {
                collect_time: data.collect_time,
                patient: this.patient.id,
                data: data.data,
                template: data.template,
                related_type: '四诊客观化数据',
                report: data.report,
                result: data.report['中医体质'][0],
            };
            const res = await PostCepingContent(this, params, loading);
            return res.data;
        } catch (error) {
            loading.close();
            throw error;
        }
    }
    private async saveContent(data: any) {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });

        try {
            const res = await EditContent(this, data.id, data, loading);
            return res.data;
        } catch (error) {
            loading.close();
            throw error;
        }
    }

    /**
     * 保存并打印
     */
    private async goPrint() {
        let res;
        if (!this.dataQuery.content_id) {
            res = await this.saveTemplate(this.data);
        } else {
            res = await this.saveContent(this.data);
        }
        this.$store.commit("updateIfCompose", false);
        // 需要把闻诊的id也加入selectedIds
        this.selectedIds.push(res.id);
        this.$emit('goPrint', this.selectedIds);
    }

    private mounted() {
        // 拿浏览器参数
        const query = this.$route.query;
        console.log('路由参数');
        console.log(query);
        if (query.name) {
            this.dataQuery.name = query.name;
        }
        if (query.template_id) {
            this.dataQuery.template_id = query.template_id;
        }
        if (query.patient_id) {
            this.dataQuery.patient_id = query.patient_id;
            this.getPatientData();
        }
        this.$store.commit("updateIfCompose", true);
        this.getShemianmaiData();
        this.getData();
    }
}
